import { enableProdMode } from '@angular/core';
import { bootstrapApplication } from '@angular/platform-browser';
import { AppComponent } from '@app/app.component';
import { appConfig } from '@app/app.config';
import { environment } from '@environments/environment';
import { init } from '@sentry/angular';
import 'hammerjs';
import { SentryConfig } from './sentry.config';

if (environment?.production) {
  enableProdMode();
  init(SentryConfig);
}

function bootstrap() {
  bootstrapApplication(AppComponent, appConfig).catch(err => console.error(err));
}

if (document.readyState === 'complete') {
  bootstrap();
} else {
  document.addEventListener('DOMContentLoaded', bootstrap);
}
